import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import languages from './languages'
import store  from './store'
import AOS from './js/aos'

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

Vue.use(VueRouter)
Vue.use(require("vue-moment"));
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
});
new Vue({
  router,
  i18n: languages.i18n,
  store: store,
  render: h => h(App),
  mounted() {
    AOS.init({
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 400, // values from 0 to 3000, with step 50ms
      easing: 'ease',
      once:false,
      anchorPlacement: 'top-bottom', 
    })
  },
}).$mount('#app')